module.exports = __webpack_public_path__ + "img/cooperate06.ffde3d04.png";